import { IconType } from 'components/Icon';
import ActionButton from 'components/Widget/ActionButton';
import { MenuItemAction } from 'menu/MenuItem';
import { shallowEqual, useSelector } from 'react-redux';
import { selectActiveDesignSystem } from 'redux/db/reducers';
import { RootReducer } from 'redux/reducers';

interface Props {
	versionNumber?: number;
}

const RestoreVersionAction = ({ versionNumber }: Props) => {
	const { designSystem, dsHasDraft, historicalDsVersionNumber } = useSelector(
		(r: RootReducer) => ({
			designSystem: selectActiveDesignSystem(r.db, r.mode.activeDesignSystemId),
			dsHasDraft: r.db.dsHasDraft,
			historicalDsVersionNumber: r.mode.historicalDsVersionNumber,
		}),
		shallowEqual
	);

	const onClick = () => {
		const vNum = versionNumber ?? historicalDsVersionNumber;
		if (!designSystem || !vNum) return;
		MenuItemAction.createRestoreVersion(designSystem.id, vNum, dsHasDraft).callback();
	};

	const label = versionNumber ? `Restore v${versionNumber}` : 'Restore this version';

	return <ActionButton icon={IconType.HISTORY} label={label} onClick={onClick} />;
};

export default RestoreVersionAction;
